export const USER_INVITATION_SUCCEED = 'OD/USER_INVITATION_SUCCEED'

export interface UserInvitationSucceedAction {
  readonly type: typeof USER_INVITATION_SUCCEED;
  readonly payload: { username: string, password: string, vCode: string, isSsoEnabled: boolean };
}

export const raiseUserInvitationSucceed = (username: string, password: string, vCode: string, isSsoEnabled: boolean): UserInvitationSucceedAction => ({
  type: USER_INVITATION_SUCCEED,
  payload: { username, password, vCode, isSsoEnabled },
})
